import { useContext } from 'react';

import { VerificationStepperContext } from '../context';

export const useVerificationStepper = () => {
  return useContext(VerificationStepperContext);
};
